export const SejamEndpoint = {
  sendOtp: '/sejam/send-otp',
  verifyOtp: '/sejam/verify-otp',
}
